const invitedByBySessionId = new Map<string, string>()

export const setSessionInvitedByName = (sessionId: string, name: string | undefined) => {
  if (name) {
    invitedByBySessionId.set(sessionId, name)
  }
}

export const getSessionInvitedByName = (sessionId: string): string | undefined => {
  return invitedByBySessionId.get(sessionId)
}

export const clearSessionInvitedByName = (sessionId: string) => {
  invitedByBySessionId.delete(sessionId)
}
